module.exports = __webpack_public_path__ + "static/img/logo-pecos-bg.8c4695b5.png";